export const VolumeMedium = () => (
  <svg
    focusable={false}
    width='17'
    height='14'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g strokeWidth='1.5' fill='none' fillRule='evenodd'>
      <path d='M8.823.823L5.896 3.75H2C1.31 3.75.75 4.31.75 5v4c0 .69.56 1.25 1.25 1.25h3.896l2.927 2.927A.25.25 0 0 0 9.25 13V1a.25.25 0 0 0-.427-.177z' />
      <path
        d='M12.12 9.123A2.99 2.99 0 0 0 13 7a2.99 2.99 0 0 0-.876-2.119m2.105 6.376A5.981 5.981 0 0 0 16 7c0-1.656-.67-3.155-1.756-4.241'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
  </svg>
);
